import { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
// import './App.scss';
//import logo from './logo.svg';
//import Login from './routes/login';
//import Administrator from './routes/administrator';
//import LiveView from './routes/liveview';
//import LiveViewList from './routes/liveviewlist';


export default function Home() {

  const token = localStorage.getItem("proxyAuthToken");
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      navigate('/login')
    } else {
      //navigate('/homepage/')
      navigate('/liveview/');
    }
  }, [token, navigate]);

  return null;

}
